<div
  data-testid="toast-container"
  class="pointer-events-none fixed right-0 top-4 z-[2147483647] flex w-full max-w-[min(520px,calc(100vw-2rem))] flex-col gap-3 sm:top-28">
  @for (toast of toasts(); track toast.id) {
  <div class="rec-toast pointer-events-auto relative flex w-full items-center gap-[19px] rounded-l-[100px] p-2"
    [ngClass]="variantFor(toast.type).bgClass" [attr.role]="variantFor(toast.type).ariaRole"
    [attr.aria-live]="variantFor(toast.type).ariaLive">
    <div class="relative h-[116px] w-[116px] flex-shrink-0">
      <div class="absolute inset-0 rounded-full bg-brand-brown"></div>
      <img src="https://storage.googleapis.com/tribuu-public/assets/images/toast/welcome-mascot.png" alt=""
        aria-hidden="true" class="absolute inset-0 h-full w-full rounded-full object-cover object-top" />
    </div>

    <div class="flex min-w-0 flex-1 flex-col gap-3 text-brand-navy">
      <p class="font-futura-medium text-[21px] leading-none">{{ toast.title }}</p>
      @if (toast.body) {
      <p class="font-futura-medium-italic text-lg leading-none">
        {{ toast.body }}
      </p>
      }
    </div>

    <button type="button"
      class="absolute -left-2 -top-2 flex h-[35px] w-[35px] items-center justify-center rounded-full bg-[rgba(156,107,85,0.53)] text-brand-brown transition-colors hover:bg-brand-brown/70 focus:outline-none focus:ring-2 focus:ring-brand-brown/40"
      (click)="dismiss(toast.id)" aria-label="Cerrar notificación">
      <svg class="h-[18px] w-[18px]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"
        aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>
  }
</div>